export default {

    name: "AjaxInput",

    props: ['endpoint'],

    data() {
        return {
            loading: true,
            validationError: null,
            value: null,
            disabled: true
        }
    },

    mounted() {
        axios.get(this.endpoint).then(response => {
            this.loading = false;
            this.value = response.data;
            this.disabled = false;
        }).catch(error => {
            this.loading = false;
            // because component might have loader with transition and then there is "another one"
            setTimeout(() => {
                this.validationError = error.response.data;
            }, this.$el.querySelector('.loader') ? 300 : 0);
        });
    },

};
